import React from 'react';

import { useIsDesktop } from '@vk-hr-tek/ui/hooks';
import { Box } from '@vk-hr-tek/ui/Box';

import { useIsWidget, useSelector } from '@app/hooks';
import { useHeaderPageProps } from '@app/context';

import { MobileMenu } from '../MobileMenu';
import { User } from '../../user';
import { selectUserRepresentative, usePermissions } from '../../../user';
import { BellNotifications } from '../../../bell-notifications/widgets';

import { SearchInput } from './SearchInput';
import { useStyles } from './Header.styles';

export const Header = () => {
  const isDesktop = useIsDesktop();
  const isWidget = useIsWidget();
  const { classes } = useStyles();
  const headerPageProps = useHeaderPageProps();
  const { view_social_news: showSearch } = usePermissions('general');

  const userRepresentative = useSelector(selectUserRepresentative);

  const headerPaddingY = isDesktop ? '12' : '8';

  const headerPaddingCondition =
    window.REACT_APP_VKHRTEK_LK_DISABLED && !userRepresentative
      ? '16'
      : headerPaddingY;

  const justifyContentCondition =
    isDesktop || isWidget ? 'flex-end' : 'space-between';

  const bellComponent = headerPageProps?.bellComponent;
  const userComponent = headerPageProps?.userComponent;

  return (
    <Box className={classes.header} py={headerPaddingCondition}>
      <Box
        justifyContent={justifyContentCondition}
        alignItems="center"
        display="flex"
        gap="16"
      >
        {!isDesktop && !isWidget && (
          <Box display="flex">
            <MobileMenu />
          </Box>
        )}
        {showSearch && <SearchInput placeholder="Поиск по порталу" />}

        {isDesktop && (bellComponent ? bellComponent : <BellNotifications />)}

        {userComponent ? userComponent : <User />}
      </Box>
    </Box>
  );
};
